import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { VisitImagesResponse } from '../@types/visits';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

interface UseGetLatestImagesForVisitParams {
  patientId: string;
  visitId: number;
  limit?: number;
  options?: UseQueryOptions<VisitImagesResponse>;
  appointmentId?: string;
}

export const useGetLatestImagesForVisit = ({
  patientId,
  limit = 50,
  options,
  visitId,
  appointmentId,
}: UseGetLatestImagesForVisitParams) => {
  const path = `${endpoints.patient}/${endpoints.visits}/${visitId}/${endpoints.images}`;

  return useQuery(
    [
      endpoints.visits,
      endpoints.images,
      visitId,
      limit,
      patientId,
      appointmentId,
    ],
    // @ts-expect-error TS(2769): No overload matches this call.
    () => makeAPIRequestReactQuery(path, { limit, patientId }),
    {
      enabled: visitId >= 0,
      ...options,
    },
  );
};
